/**
 * Сокращает слово "корпус" до "к" в строке, игнорируя регистр букв.
 *
 * Примеры:
 * - "дом 10 корпус 2" -> "дом 10 к 2"
 * - "КОРПУС 3" -> "к 3"
 * - "ул. Ленина, корпус 1" -> "ул. Ленина, к 1"
 */
export const shortenBuildingCorpus = (value: string) => {
  return value.replace(/корпус/gi, 'к');
};
